import React, { useState } from 'react';
import { motion } from 'framer-motion';
type MenuItem = {
  name: string;
  price: string;
  description?: string;
  options?: string;
};
type MenuCategory = {
  id: string;
  title: string;
  description?: string;
  items: MenuItem[];
  notices?: string[];
};
const menuData: MenuCategory[] = [{
  id: 'starters',
  title: 'STARTERS',
  items: [{
    name: 'The Over A-Cheeser',
    price: '$12',
    description: 'Five cheeses combined & baked on our flatbread, with red sauce'
  }, {
    name: 'Toasted Beef Ravioli',
    price: '$8',
    description: 'Ten crispy ravioli, with red sauce'
  }, {
    name: 'Fried Mozzarella',
    price: '$10',
    description: 'Five hand-breaded mozzarella, fried crispy, served with a side of red sauce'
  }, {
    name: 'Fried Dill Pickles',
    price: '$10',
    description: 'Hand-breaded dill pickle chips, fried crispy, served with a side of Ranch'
  }, {
    name: 'Bang Bang Shrimp',
    price: '$15',
    description: 'Hand-breaded shrimp, drizzled with tangy sauce'
  }, {
    name: 'Loaded Idahos',
    price: '$10',
    description: 'French Fried topped with Colby Jack cheese and bacon, served with Ranch',
    options: 'Add Pork Belly +$6'
  }, {
    name: 'Pork Belly',
    price: '$12',
    description: 'Thick Cut Pork Belly, over maple syrup'
  }]
}, {
  id: 'wings',
  title: 'WINGS',
  description: 'Fresh Brine BONE-IN Jumbo Wings, served NAKED OR with your choice of sauce, with celery, carrots & Bleu Cheese or Ranch',
  items: [{
    name: 'Bone-In Wings',
    price: '10 Wings $16 | 20 Wings $28'
  }, {
    name: 'BONELESS Breaded Wings',
    price: '10 Wings $12'
  }],
  notices: ["Sauces: Kentucky Kickin' Bourbon (Mild), Manganaro Habanero (Medium), Warehouse Heat (Hot)"]
}, {
  id: 'salads',
  title: 'SALADS',
  items: [{
    name: 'Classic Caesar',
    price: 'Chicken $14 | Shrimp $16'
  }, {
    name: 'Wild Buffalo',
    price: 'Chicken $14 | Shrimp $16',
    description: 'Grilled Chicken or Shrimp tossed in Buffalo sauce, iceberg & romaine, blue cheese crumbles, bacon, tomatoes, & carrots, with Bleu Cheese dressing'
  }, {
    name: 'Gyro Greek on Green',
    price: '$16',
    description: "Tomatoes, feta, black olives, green peppers, red onions & pepperoncini's, tops romaine & iceberg, with Tzatziki dressing & grilled Gyro meat"
  }, {
    name: 'Greek',
    price: 'Chicken $13 | Plain $10'
  }, {
    name: 'The Redneck Chef',
    price: '$13',
    description: 'Ham, bacon, boiled egg, tomatoes, carrots, shredded cheddar, on mixed lettuce, with 1000 Island dressing'
  }, {
    name: 'The Wedge',
    price: '$10',
    description: 'Crisp iceberg wedge, tomatoes, bacon, bleu cheese crumbles, Ranch or Bleu Cheese dressing'
  }, {
    name: 'Side Salad',
    price: '$4'
  }, {
    name: 'Side Caesar',
    price: '$4'
  }],
  notices: ['Dressings: Ranch, Bleu Cheese, 1000 Island, Zesty Italian, Tzatziki']
}, {
  id: 'strombolis',
  title: 'STROMBOLIS',
  description: 'All Strombolis are stuffed with mozzarella & rolled, then baked in our pizza oven. Add ricotta cheese too for $2',
  items: [{
    name: 'Build Your Own Stromboli',
    price: 'starts at $12',
    description: 'Melted mozzarella, toppings $2 each'
  }, {
    name: 'The Warehouse',
    price: '$16',
    description: 'Pepperoni, sausage, salami, ham, green peppers, onions, mozzarella baked with homemade red sauce'
  }, {
    name: 'Bacon Cheeseburger',
    price: '$16',
    description: 'Beef, bacon, onions with cheddar & mozzarella cheese'
  }, {
    name: 'Hot Italian',
    price: '$16',
    description: 'Ham, pepperoni, salami, green peppers, onions, with melted mozzarella with homemade red sauce'
  }, {
    name: 'The Tropical',
    price: '$16',
    description: 'Ham, bacon, pepperoni, pineapple, with melted mozzarella'
  }, {
    name: 'The Carnivore',
    price: '$18',
    description: 'Pepperoni, salami, ham, sausage, with mozzarella'
  }, {
    name: 'Gyro',
    price: '$16',
    description: 'Grilled Greek Gyro meat, stuffed with tomatoes, onions, & feta, served with a side of Tzatziki'
  }]
}, {
  id: 'specialty-pizzas',
  title: 'SPECIALTY PIZZA PIES',
  description: 'We start with made-from-scratch, hand-rolled pizza dough and hand-stretch every pie to your order. Original recipe pizza sauces topped with freshly grated whole milk mozzarella, baked crisp, sliced into triangles. 1/2 & 1/2 limited to SAME sauce pies.',
  items: [{
    name: 'The Kitchen Sink',
    price: '10" $17 | 14" $22',
    description: 'Pepperoni, crumbled sausage, ham, onions, green peppers, mushrooms & black olives'
  }, {
    name: 'Meaty Madness',
    price: '10" $18 | 14" $23',
    description: 'Pepperoni, salami, sausage, ham & bacon'
  }, {
    name: 'Pork-A-Palooza',
    price: '10" $18 | 14" $23',
    description: 'Our house roasted pork belly, house-made pork sausage, bacon, & sweet ham over ricotta cheese, topped with melted Colby Jack & mozzarella'
  }, {
    name: 'Jimmy Buffet',
    price: '10" $13 | 14" $18',
    description: 'Our "Margherita" pizza—homemade basil pesto, topped with tomatoes, fresh mozzarella, roasted garlic'
  }, {
    name: 'Paradise Pie',
    price: '10" $14 | 14" $19',
    description: 'Smokey bacon, sweet ham, & pineapple, red pizza sauce with melted mozzarella'
  }, {
    name: 'Big Mac',
    price: '10" $15 | 14" $20',
    description: 'Ground beef, bacon, onions, cheddar & mozzarella cheese topped with 1000 Island, lettuce & tomatoes'
  }, {
    name: 'Buffalo Chicken',
    price: '10" $15 | 14" $20',
    description: 'Buffalo sauce, grilled chicken, crispy bacon, jalapeños, topped with bleu cheese crumbles, mozzarella, drizzled with Ranch'
  }, {
    name: "Ragin' Cajun",
    price: '10" $19 | 14" $24',
    description: 'Roasted garlic olive oil, topped with grilled shrimp, house-marinated grilled chicken breast, grilled onions, green peppers, tomatoes, cajun seasoning with mozzarella & Cajun ranch'
  }]
}, {
  id: 'quesadillas',
  title: 'ITALIAN QUESADILLAS',
  description: 'Quesadillas are filled with mozzarella & ingredients, baked in our pizza oven, then folded flat, cut into triangles.',
  items: [{
    name: 'Buffalo Chicken Ranch',
    price: '$16',
    description: 'Hand-breaded chicken, tossed in our house Buffalo sauce, bacon, jalapeños & cheddar, with a side of Ranch'
  }, {
    name: 'Chicken Parmesan',
    price: '$16',
    description: 'Hand-breaded chicken, ricotta & marinara'
  }, {
    name: 'Greek',
    price: '$16',
    description: 'Grilled Greek Gyro meat, tomatoes, green olives, caramelized onions, feta, served with a side of Tzatziki'
  }, {
    name: 'Hot Chic',
    price: '$16',
    description: 'Grilled chicken, crispy bacon, & mozzarella, with Ranch'
  }, {
    name: 'Tiger King',
    price: '$16',
    description: 'Beef, bacon, onions, cheddar, mozzarella, with Tiger sauce'
  }, {
    name: 'Meat Lover',
    price: '$18',
    description: 'Pepperoni, sausage, salami, ham, Bacon'
  }]
}, {
  id: 'build-pizza',
  title: 'BUILD YOUR OWN PIZZA PIE',
  items: [{
    name: '16" Regular CHEESE Pie',
    price: '$16',
    description: 'Toppings extra'
  }],
  notices: ['SAUCES ($3): Red Pizza Sauce, Ricotta White Wine Sauce, Roasted Garlic & Olive Oil, Pesto, Garlic Butter, BBQ, Ranch, Tzatziki', 'CHEESES ($2 each): Mozzarella, Feta, Ricotta, Bleu Cheese, Cheddar', 'MEATS ($5 each): Pepperoni, Sausage, Ham, Bacon, Salami, Grilled Chicken', 'PREMIUM MEATS ($6 each): Grilled Shrimp & Ground Beef, Greek Gyro Meat', 'VEGGIES ($3 each): Banana Peppers, Black Olives, Green Olives, Tomatoes, Green Peppers, Mushrooms, Onions, Pineapple, Roasted Garlic']
}, {
  id: 'pastas',
  title: 'PASTAS',
  description: 'We make our pasta fresh using only Semolina and water! All pastas are cooked to your order.',
  items: [{
    name: 'Pasta Carbonara',
    price: '$18',
    description: 'Ham, bacon, & mushrooms, with creamy Bucatini pasta'
  }, {
    name: 'Pasta Alfredo',
    price: '$16',
    description: 'Creamy Alfredo over fresh Mafalda pasta'
  }, {
    name: 'Pasta Margherita',
    price: '$16',
    description: 'Sautéed grape tomatoes, basil pesto, with garlic butter, white wine sauce, over Mafalda pasta'
  }, {
    name: 'Loaded Louisiana Cajun Oil',
    price: '$25',
    description: 'Sautéed shrimp, chicken, & sausage, roasted garlic, onions, green peppers & tomatoes, over fresh Mafalda pasta'
  }, {
    name: 'Cajun Alfredo',
    price: 'Chicken $22 | Shrimp $25',
    description: 'Mafalda pasta, roasted garlic, grilled onions, green peppers, & tomatoes, in creamy Cajun Alfredo sauce'
  }, {
    name: 'Vodka Rosé Alfredo',
    price: '$18',
    description: 'Marinara & Alfredo tossed with tomatoes, onions, Campanella pasta'
  }, {
    name: 'MAC-N-CHEESE',
    price: 'Plain $10 | Pork Belly $16',
    description: 'Creamy cheese blend of Parmesan, Romano & Asiago over Campanella pasta, topped with melted Colby Jack & mozzarella'
  }],
  notices: ['ADD GRILLED CHICKEN $5 | ADD GRILLED SHRIMP $7']
}, {
  id: 'on-a-bun',
  title: 'ON A BUN',
  description: 'Cooked to order on toasted Brioche bun with Crispy Fries.',
  items: [{
    name: 'The Warehouse Cheese Burger',
    price: '$14',
    description: 'Fresh ground beef, with tomatoes, pickles, cheese, grilled on the flat top'
  }, {
    name: 'Grilled Chicken',
    price: '$15',
    description: 'Fresh chicken breast, grilled to perfection'
  }, {
    name: 'Roasted Pork Belly',
    price: '$15',
    description: 'House roasted Pork Belly'
  }]
}];
export function MenuSection() {
  const [activeCategory, setActiveCategory] = useState(menuData[0].id);
  const scrollToCategory = (id: string) => {
    setActiveCategory(id);
    const element = document.getElementById(`category-${id}`);
    if (element) {
      const y = element.getBoundingClientRect().top + window.scrollY - 100;
      window.scrollTo({
        top: y,
        behavior: 'smooth'
      });
    }
  };
  return <section id="menu" className="py-24 bg-white relative" data-id="element-80">
      <div className="container mx-auto px-4 max-w-6xl relative z-10" data-id="element-81">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-center mb-16" data-id="element-82">
          <h2 className="text-4xl md:text-5xl font-heading font-bold text-black mb-4 uppercase tracking-wide" data-id="element-83">
            Our Menu
          </h2>
          <div className="w-24 h-1 bg-red-600 mx-auto" data-id="element-84"></div>
        </motion.div>

        {/* Sticky Category Navigation */}
        <div className="sticky top-[72px] z-40 bg-white/90 backdrop-blur-md py-4 mb-16 border-b border-neutral-200 shadow-sm overflow-x-auto" data-id="element-85">
          <div className="flex space-x-2 md:space-x-3 px-2 min-w-max mx-auto justify-center" data-id="element-86">
            {menuData.map(category => <button key={category.id} onClick={() => scrollToCategory(category.id)} className={`px-5 py-2.5 rounded-full text-sm md:text-base font-heading font-medium transition-all whitespace-nowrap ${activeCategory === category.id ? 'bg-red-600 text-white shadow-md scale-105' : 'bg-neutral-100 text-neutral-700 hover:bg-neutral-200 hover:text-black'}`} data-id="element-87">
                {category.title}
              </button>)}
          </div>
        </div>

        {/* Menu Categories */}
        <div className="space-y-24" data-id="element-88">
          {menuData.map(category => <div key={category.id} id={`category-${category.id}`} className="scroll-mt-36" data-id="element-89">
              <motion.div initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true,
            margin: '-100px'
          }} transition={{
            duration: 0.4
          }} className="mb-10 border-b-2 border-neutral-900 pb-4 flex items-end justify-between" data-id="element-90">
                <div data-id="element-91">
                  <h3 className="text-3xl font-heading font-bold text-black tracking-wider" data-id="element-92">
                    {category.title}
                  </h3>
                  {category.description && <p className="text-neutral-600 mt-2 italic max-w-3xl" data-id="element-93">
                      {category.description}
                    </p>}
                </div>
              </motion.div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-x-16 gap-y-6" data-id="element-94">
                {category.items.map((item, index) => <motion.div initial={{
              opacity: 0,
              y: 15
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true,
              margin: '-50px'
            }} transition={{
              duration: 0.3,
              delay: index * 0.05
            }} key={index} className="flex flex-col p-4 -mx-4 rounded-xl hover:bg-neutral-50 transition-colors group" data-id="element-95">
                    <div className="flex justify-between items-baseline mb-1" data-id="element-96">
                      <h4 className="text-xl font-bold text-black font-heading tracking-wide group-hover:text-red-700 transition-colors" data-id="element-97">
                        {item.name}
                      </h4>
                      <div className="flex-grow border-b border-dotted border-neutral-300 mx-4 opacity-70" data-id="element-98"></div>
                      <span className="text-lg font-bold text-red-600 whitespace-nowrap" data-id="element-99">
                        {item.price}
                      </span>
                    </div>
                    {item.description && <p className="text-neutral-600 text-sm leading-relaxed mt-1" data-id="element-100">
                        {item.description}
                      </p>}
                    {item.options && <p className="text-red-600 text-sm font-medium mt-1.5" data-id="element-101">
                        {item.options}
                      </p>}
                  </motion.div>)}
              </div>

              {/* Special handling for Build Your Own Pizza notices to make them look like a grid */}
              {category.id === 'build-pizza' && category.notices ? <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-102">
                  {category.notices.map((notice, idx) => {
              const [label, ...rest] = notice.split(':');
              return <div key={idx} className="bg-neutral-50 border border-neutral-200 p-5 rounded-xl" data-id="element-103">
                        <h5 className="font-bold text-red-600 font-heading tracking-wide mb-2" data-id="element-104">
                          {label}
                        </h5>
                        <p className="text-sm text-neutral-700 leading-relaxed" data-id="element-105">
                          {rest.join(':').trim()}
                        </p>
                      </div>;
            })}
                </motion.div> : category.notices ? <motion.div initial={{
            opacity: 0
          }} whileInView={{
            opacity: 1
          }} viewport={{
            once: true
          }} className="mt-8 bg-neutral-50 p-5 rounded-xl border border-neutral-200" data-id="element-106">
                  {category.notices.map((notice, idx) => <p key={idx} className="text-sm text-neutral-700 font-medium mb-1 last:mb-0 flex items-start gap-2" data-id="element-107">
                      <span className="text-red-500 mt-0.5" data-id="element-108">•</span> {notice}
                    </p>)}
                </motion.div> : null}
            </div>)}
        </div>

        {/* Global Notices */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="mt-24 bg-[#1a3a2a] text-white p-8 rounded-2xl shadow-xl relative overflow-hidden" data-id="element-109">
          <div className="absolute top-0 left-0 w-2 h-full bg-red-600" data-id="element-110"></div>
          <h4 className="font-heading font-bold text-2xl mb-4 tracking-wide" data-id="element-111">
            Important Notices
          </h4>
          <ul className="space-y-3 text-neutral-300 font-medium" data-id="element-112">
            <li className="flex items-center gap-3" data-id="element-113">
              <div className="w-1.5 h-1.5 rounded-full bg-red-500" data-id="element-114"></div>
              20% Gratuity on a Party of 8 or more.
            </li>
            <li className="flex items-center gap-3" data-id="element-115">
              <div className="w-1.5 h-1.5 rounded-full bg-red-500" data-id="element-116"></div>
              3% Added to Credit Card Sales.
            </li>
            <li className="flex items-center gap-3 text-red-400" data-id="element-117">
              <div className="w-1.5 h-1.5 rounded-full bg-red-500" data-id="element-118"></div>
              *PRICES CHANGE WITHOUT NOTICE DUE TO CHANGING FOOD COSTS*
            </li>
          </ul>
        </motion.div>
      </div>
    </section>;
}